import { Dialog, Divider, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import ProgressIndicatorContainer from "components/ProgressIndicatorContainer";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { DiagnosticDetailsForm } from "components/AlertsManagement/Case/form/DiagnosticDetailsForm";
import { useGetCasesByMachineId } from "hooks/cases/useGetCasesByMachineId";
import { Autocomplete } from "components/Autocomplete";
import { diagnosticValidation } from "components/AlertsManagement/Case/form/diagnosticValidationSchema";
import * as Yup from "yup";
import DialogTitle from "@mui/material/DialogTitle";

const validationSchema = Yup.object({
  case: Yup.object()
    .label("Case")
    .required()
    .nullable(),
  diagnostic: diagnosticValidation
});

export const ExistingCaseFormDialog = ({
  open,
  initialValues,
  machineId,
  onClose,
  loading,
  error,
  onSubmit
}) => {
  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit: values => onSubmit(values)
  });
  const { loading: casesLoading, cases } = useGetCasesByMachineId(machineId);

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={onClose}
      aria-labelledby="alarm-trend-slide-title"
    >
      <DialogTitle>Add Alert to existing Case</DialogTitle>
      <form onSubmit={formik.handleSubmit} noValidate>
        <DialogContent>
          <Grid container direction="row" alignItems="center" spacing={3}>
            <Grid
              container
              item
              direction="row"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={12} sm={4}>
                <Autocomplete
                  label="Select Case"
                  name="case"
                  id="case"
                  required
                  loading={casesLoading}
                  options={cases ?? []}
                  getOptionLabel={option => option.display_id}
                  value={formik.values.case}
                  onChange={(e, value) => formik.setFieldValue("case", value)}
                  onBlur={formik.handleBlur}
                  error={formik.touched.case && Boolean(formik.errors.case)}
                  helperText={formik.touched.case && formik.errors.case}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <DiagnosticDetailsForm formik={formik} />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <ProgressIndicatorContainer loading={loading}>
            {error && (
              <Typography color="error">
                An error occurred while creating the case, please try again
              </Typography>
            )}
            <Button variant="outlined" color="primary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" type="submit">
              Add to Existing Case
            </Button>
          </ProgressIndicatorContainer>
        </DialogActions>
      </form>
    </Dialog>
  );
};

ExistingCaseFormDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  machineId: PropTypes.number,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.bool
};
